import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  List,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material";
import { useGlobalLoading } from "../../store/GlobalLoading";
import { useModalStore } from "../../store/ModalStore";
import PlayStore from "../../assets/images/playstore_logo.png";
import AppStore from "../../assets/images/appstore_logo.png";

export function ConfirmPinRescue() {
  const { closeModal } = useModalStore();
  const { openLoading, closeLoading } = useGlobalLoading();

  const linksNba = [
    {
      href: "https://apps.apple.com/br/app/nba-app-oficial/id484672289",
      name: "AppStore",
      width: "48%",
      image: AppStore,
    },
    {
      href: "https://play.google.com/store/apps/details?id=com.nbaimd.gametime.nba2011&hl=pt_BR&gl=US",
      name: "PlayStore",
      width: "50%",
      image: PlayStore,
    },
  ];

  return (
    <>
      <DialogTitle>
        {"Parabéns, você resgatou seu NBA League Pass com Sucesso!"}
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" sx={{ marginTop: 2 }}>
          Parabéns, você resgatou seu NBA League Pass com sucesso! Siga os
          próximos passos.
        </Typography>
        <Grid
          container
          flexDirection={"row"}
          flexWrap={"nowrap"}
          alignItems={"center"}
          justifyContent={"center"}
          marginTop={2}
        >
          {linksNba.map((link) => (
            <Grid item width={link.width}>
              <a href={link.href} target="_blank">
                <img width={"100%"} src={link.image} alt={link.name} />
              </a>
            </Grid>
          ))}
        </Grid>
        <List>
          <ListItem>
            <ListItemText>
              1. Baixe o app da NBA (
              <strong>caso já tenha lembre-se de deslogar sua conta</strong>);
            </ListItemText>
          </ListItem>
          <ListItem>
            <ListItemText>
              2. Faça login em <strong>"mais opções de login"</strong>;
            </ListItemText>
          </ListItem>
          <ListItem>
            <ListItemText>
              3. Fazer login com <strong>"outros parceiros"</strong>;
            </ListItemText>
          </ListItem>
          <ListItem>
            <ListItemText>
              4. Em <strong>"selecione seu provedor"</strong> escolha <strong>"
              VOUCHER"</strong>;
            </ListItemText>
          </ListItem>
          <ListItem>
            <ListItemText>
              5. Digite o email (<strong>código do assinante</strong>) e senha que acabou de
              criar;
            </ListItemText>
          </ListItem>
          <ListItem>
            <ListItemText>
            6. Autorize o acesso e acesse sua conta ID NBA, caso não tenha,
            cadastre-se em <strong>"sign in"</strong>.
            </ListItemText>
          </ListItem>
        </List>
      </DialogContent>

      <DialogActions>
        <Button
          sx={{ color: "#17408B" }}
          onClick={() => {
            closeModal();
            openLoading();
            setTimeout(() => {
              closeLoading();
            }, 500);
          }}
        >
          Fechar
        </Button>
      </DialogActions>
    </>
  );
}
